import React from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'reactstrap';
import Jobs from '../data/jobs.json';
import '../assets/css/careers.css';
import asset from '../assets/images/careers.jpg'

class Careers extends React.Component {
    componentDidMount() {
        this.setState({ Jobs })
    }

    state = {
        Jobs: {
            Jobs: []
        },
    }
    render() {
        const { Jobs } = this.state
        return (
            <div className='career-cont'>
                {/* <header className="preheader">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-9">
                                <div className="card values">
                                    <div className="row">
                                        <div className="col-sm-4 col-md-4 val">
                                            <div className="info">
                                                <h4 className="bold deep-blue-text">Core Values</h4>
                                                <p>Our corporate values and beliefs are at the core of what we do, and provide us with a framework</p>
                                                <Link to="/" className="gray-bordered-button-sm">Read more</Link>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 col-md-4 val">
                                            <div className="info">
                                                <h4 className="bold deep-blue-text">Our Culture</h4>
                                                <p>Our corporate values and beliefs are at the core of what we do, and provide us with a framework</p>
                                                <Link to="/" className="gray-bordered-button-sm">Read more</Link>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 col-md-4 val">
                                            <div className="info">
                                                <h4 className="bold deep-blue-text">Corporate Social Responsibility</h4>
                                                <Link to="/" className="gray-bordered-button-sm">Read more</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="card full-card service-card burgundy-bg">
                                    <div className="column white-text">
                                        <span>CAREERS</span>
                                        <div className="card-body">
                                            <p className="block-heading">Join the winning team</p>

                                            <Link to="/careers" className="white-button-sm">Apply</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header> */}
                {/* <div className='postheader white-text'>
                    <h1 className='bold'>Vacancies</h1>
                    <p className='light-blue-text'>Our employees are one of our most important assets as their commitment and engagement is essential to delivering true value</p>
                </div> */}
                <header className="banner" style={{backgroundImage: `url(${asset})`, }}>
                    <div className="container-fluid">
                        <div className='paginations'>
                            <div className="gray-button-sm">
                                <Link to='/'>Home</Link>
                            </div>
                            <div className="blue-button-sm">
                                <Link to='/careers'>Vacancies</Link>
                            </div>
                        </div>
                        <div className="header-text">
                            <h1 className='bold'>Vacancies</h1>
                        </div>
                        <div className="col-sm-8 col-md-7 no-gutter-left">
                            <p>Our employees are one of our most important assets as their commitment and engagement is essential to delivering true value</p>
                        </div>
                    </div>
                </header>
                <div className='section jobs'>
                    <div className="container-fluid">
                        <div className='row'>
                            <div className='col-12 col-md-10'>
                                <Table hover size="sm">
                                    <thead>
                                        <tr className="d-flex">
                                            <th className='text-uppercase bold col-4'>Job Title</th>
                                            <th className="text-uppercase bold col-3">Location</th>
                                            <th className="text-uppercase bold col-3">Expiry</th>
                                            <th className='text-uppercase bold col-2'></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            Jobs.Jobs.map(job => {
                                                return (
                                                    <tr key={job.id} className="d-flex">
                                                        <td className="col-4">{job.title}</td>
                                                        <td className="col-3 text-uppercase">{job.location}</td>
                                                        <td className="col-3">{job.expiry}</td>
                                                        <td className="col-2"><Link className='btn btn-link light-blue-text' to='/application'>Apply</Link></td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Careers;